import script from "./DashboardHomeView.vue?vue&type=script&lang=js"
export * from "./DashboardHomeView.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__